import '../../style/';
import '../../modal/style';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/swipe-action/style/index.web.tsx
 **/